// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalOptionsDesktop_wrapper__t1x1L","fon":"ModalOptionsDesktop_fon__VqcMd","container":"ModalOptionsDesktop_container__10b-Y","block":"ModalOptionsDesktop_block__sYUmZ"};